import { indexData } from "@/mocks/homeData";

const colorMap: Record<string, string> = {
  accent: "bg-accent-100/60 text-accent-400 group-hover:bg-accent-500 group-hover:text-background-950",
  primary: "bg-primary-100/20 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-950",
  secondary: "bg-secondary-100/50 text-secondary-300 group-hover:bg-secondary-500 group-hover:text-background-950",
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">内容索引</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">全类型影视分类导航，快速找到想看的内容</p>
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group flex flex-col items-center justify-center p-4 md:p-6 rounded-lg bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <span className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full mb-2 md:mb-3 transition-colors ${colorMap[item.color] || colorMap.primary}`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </span>
              <h3 className="text-foreground-200 text-xs md:text-sm font-medium mb-1 whitespace-nowrap">{item.title}</h3>
              <span className="text-foreground-600 text-xs">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}